<template>
  <wapPopup v-model="recommendVisible" position="bottom">
    <div class="circle-recommend">
			<div class="circle-recommend-list">
        <h2 class="heading">{{$t('joinNewCircles')}}</h2>
				<ul class="list">
					<li
						class="item"
						v-for="item of list"
						:key="item.circleId"
						@click="selectCicle(item)"
					>
						<span class="cr-radio" :class="{active: selectCircleList.includes(item.circleId)}"><i></i></span>
						<van-image width="100%" height="85px" radius="4px" fit="cover" :src="item.circleAvatar" />
						<p class="title">{{ item.circleName }}</p>
					</li>
				</ul>
			</div>
      <div class="footer">
				<van-button round block type="default" @click="closeDialog">
					{{$t('skip')}}
				</van-button>
				<van-button round block class="submit-button" @click="onSubmit">
					{{$t('ok')}}
				</van-button>
			</div>
		</div>
  </wapPopup>
</template>
<script setup>
import { ref, watch, watchEffect, onMounted, getCurrentInstance } from 'vue';
import http from '@/service'
const { proxy } = getCurrentInstance()
const props = defineProps({
})
const recommendVisible = ref(false)
const list = ref([])
const selectCircleList = ref([])
const closeDialog = () => {
  recommendVisible.value = false
  http.skipRecommendCircle()
}
const selectCicle = (item) => {
  if(selectCircleList.value.includes(item.circleId)){
    for (let i = selectCircleList.value.length - 1; i >= 0; i--) {
      if (selectCircleList.value[i] === item.circleId) {
        selectCircleList.value.splice(i, 1)
      }
    }
  }else{
    selectCircleList.value.push(item.circleId)
  }
}
const onSubmit = async () => {
  if(selectCircleList.value.length === 0){
    proxy.$toast({
      message: proxy.$t('selectCircle')
    })
    return
  }
  const { code, data, msg} = await http.batchJoinCircle(selectCircleList.value)
  if (code === 200) {
    location.reload()
  }
}
const getRecommendList = async () => {
  const { code, data, msg} = await http.getRecommendCircle()
  if (code === 200) {
    list.value = data
    if(list.value.length > 0){
      recommendVisible.value = true
      selectCircleList.value = list.value.map(v => v.circleId)
    }
  }
}
onMounted(() => {
  getRecommendList()
})
</script>
<style lang="postcss" scoped>
.circle-recommend {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  width: 100vw;
  height: calc(100vh - var(--orbit-nav-height, 0px) - var(--browser-address-bar, 0px) - 40px);
  padding: 20px;
  box-sizing: border-box;
  .heading {
    font-family: "orbit-M";
    font-size: 16px;
    line-height: 21px;
    text-align: center;
  }
  .circle-recommend-list {
    height: calc(100vh - (var(--orbit-nav-height, 0px) + 44px) - var(--browser-address-bar, 0px) - 40px);
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 120px;

    .item {
      width: calc(50% - 10px);
      margin-top: 24px;
      position: relative;

      &:nth-child(2n - 1){
        margin-right: 20px;
      }

      .title {
        font-family: "orbit-R";
        font-size: 14px;
        line-height: 20px;
        color: var(--text-primary);
      }

      .cr-radio {
        position: absolute;
        right: 8px;
        top: 8px;
        z-index: 2;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        background-color: transparent;
        border: 1px solid var(--black-line);
        box-sizing: border-box;

        &.active {
          background: #FFF;
          border-width: 5px;
          border-color: var(--theme);
        }
      }
    }
  }

  .footer {
    position: fixed;
    display: flex;
    width: 100%;
    background-color: var(--color-background-primary);
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    z-index: 2000;
    button {
      width: calc((100% - 20px) / 2);
    }
    
    .submit-button {
      background: var(--theme);
      color: #fff;
      border: none;
    }
  }
}
</style>